export default "__VITE_ASSET__60e87486__"